const sideBarDef = {
  toolPanels: [
    {
      id: 'columns',
      labelDefault: 'Colonnes',
      labelKey: 'columns',
      iconKey: 'columns',
      toolPanel: 'agColumnsToolPanel',
      toolPanelParams: {
        suppressRowGroups: true,
        suppressValues: true,
        suppressFilterSearch: true,
      },
    },
    {
      id: 'filters',
      labelDefault: 'Filtres',
      labelKey: 'filters',
      iconKey: 'filter',
      toolPanel: 'agFiltersToolPanel',
      toolPanelParams: {
        suppressRowGroups: true,
        suppressValues: true,
      },
    },
  ],
  position: 'right',
};

export default sideBarDef;
